/**
 * WARNING! DO NOT EDIT THIS FILE MANUALLY!
 *
 * - In the case of `npm run watch` or `npm run watch-poll` the changes
 *   to routes are being watched and rebuilt is triggered automatically.
 */

const config = {
    get url() { return window.location.origin; },
    "port": null,
    "defaults": {},
    "routes": {
        "cognito_authorize": {
            "uri": "auth/cognito",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "keep-alive": {
            "uri": "keep-alive",
            "methods": [
                "POST"
            ]
        },
        "api.v1.country.index": {
            "uri": "api/v1/country",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "api.v1.country.show": {
            "uri": "api/v1/country/{country}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "wheres": {
                "country": "[0-9]+"
            },
            "parameters": [
                "country"
            ]
        },
        "api.v1.document.index": {
            "uri": "api/v1/document",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "api.v1.document.show": {
            "uri": "api/v1/document/{document}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "wheres": {
                "document": "[0-9]+"
            },
            "parameters": [
                "document"
            ]
        },
        "api.v1.document--invitation.index": {
            "uri": "api/v1/document--invitation",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "api.v1.document--invitation.show": {
            "uri": "api/v1/document--invitation/{document__invitation}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "wheres": {
                "document__invitation": "[0-9]+"
            },
            "parameters": [
                "document__invitation"
            ]
        },
        "api.v1.file.index": {
            "uri": "api/v1/file",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "api.v1.file.show": {
            "uri": "api/v1/file/{file}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "wheres": {
                "file": "[0-9]+"
            },
            "parameters": [
                "file"
            ]
        },
        "api.v1.folder.index": {
            "uri": "api/v1/folder",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "api.v1.folder.show": {
            "uri": "api/v1/folder/{folder}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "wheres": {
                "folder": "[0-9]+"
            },
            "parameters": [
                "folder"
            ]
        },
        "api.v1.group.index": {
            "uri": "api/v1/group",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "api.v1.group.show": {
            "uri": "api/v1/group/{group}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "wheres": {
                "group": "[0-9]+"
            },
            "parameters": [
                "group"
            ]
        },
        "api.v1.group--language.index": {
            "uri": "api/v1/group--language",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "api.v1.group--language.show": {
            "uri": "api/v1/group--language/{group__language}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "wheres": {
                "group__language": "[0-9]+"
            },
            "parameters": [
                "group__language"
            ]
        },
        "api.v1.user.index": {
            "uri": "api/v1/user",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "api.v1.user.show": {
            "uri": "api/v1/user/{user}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "wheres": {
                "user": "[0-9]+"
            },
            "parameters": [
                "user"
            ]
        },
        "api.v1.locale.country.index": {
            "uri": "api/v1/{locale}/country",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "locale"
            ]
        },
        "api.v1.locale.country.show": {
            "uri": "api/v1/{locale}/country/{country}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "wheres": {
                "country": "[0-9]+"
            },
            "parameters": [
                "locale",
                "country"
            ]
        },
        "api.v1.locale.group.index": {
            "uri": "api/v1/{locale}/group",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "locale"
            ]
        },
        "api.v1.locale.group.show": {
            "uri": "api/v1/{locale}/group/{group}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "wheres": {
                "group": "[0-9]+"
            },
            "parameters": [
                "locale",
                "group"
            ]
        },
        "home": {
            "uri": "/",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "create": {
            "uri": "create",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "tour.disable": {
            "uri": "tour/disable",
            "methods": [
                "PUT"
            ]
        },
        "tour.complete": {
            "uri": "tour/complete",
            "methods": [
                "POST"
            ]
        },
        "language.associate": {
            "uri": "languages/{locale}",
            "methods": [
                "PUT"
            ],
            "parameters": [
                "locale"
            ]
        },
        "folders.store": {
            "uri": "folders",
            "methods": [
                "POST"
            ]
        },
        "folders.update": {
            "uri": "folders/{folder}",
            "methods": [
                "PUT",
                "PATCH"
            ],
            "parameters": [
                "folder"
            ],
            "bindings": {
                "folder": "id"
            }
        },
        "guide.index": {
            "uri": "guide",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "login": {
            "uri": "login",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "logout": {
            "uri": "logout",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "groups.index": {
            "uri": "groups/{country?}/{locale?}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "country",
                "locale"
            ],
            "bindings": {
                "country": "code"
            }
        },
        "groups.associate": {
            "uri": "groups/{group}/{country}/{locale}",
            "methods": [
                "PUT"
            ],
            "parameters": [
                "group",
                "country",
                "locale"
            ],
            "bindings": {
                "group": "id",
                "country": "code"
            }
        },
        "groups.requests.access": {
            "uri": "groups/{group}/requests/access",
            "methods": [
                "POST"
            ],
            "parameters": [
                "group"
            ],
            "bindings": {
                "group": "id"
            }
        },
        "groups.requests.approve": {
            "uri": "groups/{group}/requests/{token}/approve",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "group",
                "token"
            ],
            "bindings": {
                "group": "id"
            }
        },
        "admin.users.index": {
            "uri": "admin/users",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "admin.users.destroy": {
            "uri": "admin/users/{user}",
            "methods": [
                "DELETE"
            ],
            "parameters": [
                "user"
            ],
            "bindings": {
                "user": "id"
            }
        },
        "admin.users.new": {
            "uri": "admin/users/new",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "admin.users.blocked": {
            "uri": "admin/users/blocked",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "admin.users.restore": {
            "uri": "admin/users/{userOnlyTrashed}/restore",
            "methods": [
                "POST"
            ],
            "parameters": [
                "userOnlyTrashed"
            ],
            "bindings": {
                "userOnlyTrashed": "id"
            }
        },
        "admin.users.force_destroy": {
            "uri": "admin/users/{userWithTrashed}/force-delete",
            "methods": [
                "DELETE"
            ],
            "parameters": [
                "userWithTrashed"
            ],
            "bindings": {
                "userWithTrashed": "id"
            }
        },
        "admin.users.resign": {
            "uri": "admin/users/{user}/resign",
            "methods": [
                "POST"
            ],
            "parameters": [
                "user"
            ],
            "bindings": {
                "user": "id"
            }
        },
        "admin.users.permissions.admin.assign": {
            "uri": "admin/users/{user}/permissions/admin",
            "methods": [
                "POST"
            ],
            "parameters": [
                "user"
            ],
            "bindings": {
                "user": "id"
            }
        },
        "admin.users.permissions.admin.remove": {
            "uri": "admin/users/{user}/permissions/admin",
            "methods": [
                "DELETE"
            ],
            "parameters": [
                "user"
            ],
            "bindings": {
                "user": "id"
            }
        },
        "admin.users.group_requests.approve": {
            "uri": "admin/users/{user}/group-requests/{group}/approve",
            "methods": [
                "POST"
            ],
            "parameters": [
                "user",
                "group"
            ],
            "bindings": {
                "user": "id",
                "group": "id"
            }
        },
        "admin.users.group_requests.decline": {
            "uri": "admin/users/{user}/group-requests/{group}/decline",
            "methods": [
                "POST"
            ],
            "parameters": [
                "user",
                "group"
            ],
            "bindings": {
                "user": "id",
                "group": "id"
            }
        },
        "admin.groups.index": {
            "uri": "admin/groups",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "admin.groups.create": {
            "uri": "admin/groups/create",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "admin.groups.store": {
            "uri": "admin/groups",
            "methods": [
                "POST"
            ]
        },
        "admin.groups.edit": {
            "uri": "admin/groups/{group}/edit",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "group"
            ],
            "bindings": {
                "group": "id"
            }
        },
        "admin.groups.update": {
            "uri": "admin/groups/{group}",
            "methods": [
                "PUT",
                "PATCH"
            ],
            "parameters": [
                "group"
            ],
            "bindings": {
                "group": "id"
            }
        },
        "admin.groups.synchronize": {
            "uri": "admin/groups/{group}/synchronize",
            "methods": [
                "POST"
            ],
            "parameters": [
                "group"
            ],
            "bindings": {
                "group": "id"
            }
        },
        "dashboard.statistics": {
            "uri": "dashboard/statistics",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "dashboard.charts.statistics": {
            "uri": "dashboard/charts/statistics/{type}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "type"
            ]
        },
        "dashboard.charts.country_comparisons": {
            "uri": "dashboard/charts/country-comparisons",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "dashboard.charts.metadata_comparisons.common": {
            "uri": "dashboard/charts/metadata-comparisons/{field}/common",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "field"
            ]
        },
        "dashboard.charts.metadata_comparisons.summary": {
            "uri": "dashboard/charts/metadata-comparisons/{field}/summary",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "field"
            ]
        },
        "dashboard.charts.deviation_comparisons.common": {
            "uri": "dashboard/charts/deviation-comparisons/common",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "dashboard.charts.deviation_comparisons.monthly": {
            "uri": "dashboard/charts/deviation-comparisons/monthly",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "dashboard.upload_history": {
            "uri": "dashboard/upload-history",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "dashboard.upload_history.export": {
            "uri": "dashboard/upload-history/export",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "dashboard.rules.reset": {
            "uri": "dashboard/rules-reset",
            "methods": [
                "PUT"
            ]
        },
        "documents.index": {
            "uri": "documents",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "documents.shared": {
            "uri": "documents/shared",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "documents.archive": {
            "uri": "documents/archive",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "documents.destroy": {
            "uri": "documents/delete",
            "methods": [
                "DELETE"
            ]
        },
        "documents.force_destroy": {
            "uri": "documents/force-delete",
            "methods": [
                "DELETE"
            ]
        },
        "documents.restore": {
            "uri": "documents/restore",
            "methods": [
                "POST"
            ]
        },
        "documents.invite": {
            "uri": "documents/invite",
            "methods": [
                "POST"
            ]
        },
        "documents.resign": {
            "uri": "documents/resign",
            "methods": [
                "POST"
            ]
        },
        "documents.create": {
            "uri": "documents/create",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "documents.store": {
            "uri": "documents",
            "methods": [
                "POST"
            ]
        },
        "documents.update": {
            "uri": "documents/{document}",
            "methods": [
                "POST"
            ],
            "parameters": [
                "document"
            ],
            "bindings": {
                "document": "id"
            }
        },
        "documents.update.name": {
            "uri": "documents/{document}/name",
            "methods": [
                "PUT"
            ],
            "parameters": [
                "document"
            ],
            "bindings": {
                "document": "id"
            }
        },
        "documents.auto_save": {
            "uri": "documents/{document}/auto-save",
            "methods": [
                "PUT"
            ],
            "parameters": [
                "document"
            ],
            "bindings": {
                "document": "id"
            }
        },
        "documents.editor.request": {
            "uri": "documents/{document}/editor/request",
            "methods": [
                "POST"
            ],
            "parameters": [
                "document"
            ],
            "bindings": {
                "document": "id"
            }
        },
        "documents.editor.release": {
            "uri": "documents/{document}/editor/release",
            "methods": [
                "POST"
            ],
            "parameters": [
                "document"
            ],
            "bindings": {
                "document": "id"
            }
        },
        "documents.editor.decline": {
            "uri": "documents/{document}/editor/decline",
            "methods": [
                "POST"
            ],
            "parameters": [
                "document"
            ],
            "bindings": {
                "document": "id"
            }
        },
        "documents.editor.associate": {
            "uri": "documents/{document}/editor/associate",
            "methods": [
                "POST"
            ],
            "parameters": [
                "document"
            ],
            "bindings": {
                "document": "id"
            }
        },
        "documents.editor.disassociate": {
            "uri": "documents/{document}/editor/disassociate",
            "methods": [
                "DELETE"
            ],
            "parameters": [
                "document"
            ],
            "bindings": {
                "document": "id"
            }
        },
        "documents.check": {
            "uri": "documents/{document}/check",
            "methods": [
                "POST"
            ],
            "parameters": [
                "document"
            ],
            "bindings": {
                "document": "id"
            }
        },
        "documents.import": {
            "uri": "documents/{document}/import",
            "methods": [
                "POST"
            ],
            "parameters": [
                "document"
            ],
            "bindings": {
                "document": "id"
            }
        },
        "documents.feedbacks.resolve_document": {
            "uri": "documents/{documentWhereHasDocumentRevision}/feedbacks/resolve-document",
            "methods": [
                "POST"
            ],
            "parameters": [
                "documentWhereHasDocumentRevision"
            ],
            "bindings": {
                "documentWhereHasDocumentRevision": "id"
            }
        },
        "documents.feedbacks.resolve_paragraph": {
            "uri": "documents/{documentWhereHasDocumentRevision}/feedbacks/resolve-paragraph",
            "methods": [
                "POST"
            ],
            "parameters": [
                "documentWhereHasDocumentRevision"
            ],
            "bindings": {
                "documentWhereHasDocumentRevision": "id"
            }
        },
        "documents.feedbacks.resolve_sentence": {
            "uri": "documents/{documentWhereHasDocumentRevision}/feedbacks/resolve-sentence",
            "methods": [
                "POST"
            ],
            "parameters": [
                "documentWhereHasDocumentRevision"
            ],
            "bindings": {
                "documentWhereHasDocumentRevision": "id"
            }
        },
        "documents.invitations.withdraw": {
            "uri": "documents/{document}/invitations",
            "methods": [
                "DELETE"
            ],
            "parameters": [
                "document"
            ],
            "bindings": {
                "document": "id"
            }
        },
        "documents.revisions.destroy": {
            "uri": "documents/{document}/revisions/{documentRevision}",
            "methods": [
                "DELETE"
            ],
            "parameters": [
                "document",
                "documentRevision"
            ],
            "bindings": {
                "document": "id",
                "documentRevision": "id"
            }
        },
        "documents.revisions.replicate": {
            "uri": "documents/{document}/revisions/{documentRevision}/replicate",
            "methods": [
                "POST"
            ],
            "parameters": [
                "document",
                "documentRevision"
            ],
            "bindings": {
                "document": "id",
                "documentRevision": "id"
            }
        },
        "documents.folders.destroy": {
            "uri": "documents/folders/delete",
            "methods": [
                "DELETE"
            ]
        },
        "documents.folders.append": {
            "uri": "documents/folders/append/{folderOfDocument?}",
            "methods": [
                "POST"
            ],
            "parameters": [
                "folderOfDocument"
            ]
        },
        "documents.folders.show": {
            "uri": "documents/folders/{folderOfDocument}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "folderOfDocument"
            ]
        },
        "documents.folders.create": {
            "uri": "documents/folders/{folderOfDocument}/create",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "folderOfDocument"
            ]
        },
        "documents.mark_as_final_version": {
            "uri": "documents/{document}/mark-as-final-version",
            "methods": [
                "PUT"
            ],
            "parameters": [
                "document"
            ],
            "bindings": {
                "document": "id"
            }
        },
        "documents.show": {
            "uri": "documents/{document}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "document"
            ],
            "bindings": {
                "document": "id"
            }
        },
        "documents.revisions.show": {
            "uri": "documents/{document}/revisions/{documentRevision}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "document",
                "documentRevision"
            ],
            "bindings": {
                "document": "id",
                "documentRevision": "id"
            }
        },
        "files.index": {
            "uri": "files",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "files.archive": {
            "uri": "files/archive",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "files.destroy": {
            "uri": "files/delete",
            "methods": [
                "DELETE"
            ]
        },
        "files.force_destroy": {
            "uri": "files/force-delete",
            "methods": [
                "DELETE"
            ]
        },
        "files.restore": {
            "uri": "files/restore",
            "methods": [
                "POST"
            ]
        },
        "files.send": {
            "uri": "files/send",
            "methods": [
                "POST"
            ]
        },
        "files.download": {
            "uri": "files/download",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "files.create": {
            "uri": "files/create",
            "methods": [
                "GET",
                "HEAD"
            ]
        },
        "files.store": {
            "uri": "files",
            "methods": [
                "POST"
            ]
        },
        "files.update": {
            "uri": "files/{file}",
            "methods": [
                "POST"
            ],
            "parameters": [
                "file"
            ],
            "bindings": {
                "file": "id"
            }
        },
        "files.show": {
            "uri": "files/{file}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "file"
            ],
            "bindings": {
                "file": "id"
            }
        },
        "files.edit": {
            "uri": "files/{file}/edit",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "file"
            ],
            "bindings": {
                "file": "id"
            }
        },
        "files.complete": {
            "uri": "files/{file}/complete",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "file"
            ],
            "bindings": {
                "file": "id"
            }
        },
        "files.revisions.destroy": {
            "uri": "files/{file}/revisions/{fileRevision}",
            "methods": [
                "DELETE"
            ],
            "parameters": [
                "file",
                "fileRevision"
            ],
            "bindings": {
                "file": "id",
                "fileRevision": "id"
            }
        },
        "files.revisions.download": {
            "uri": "files/{file}/revisions/{fileRevision}/download",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "file",
                "fileRevision"
            ],
            "bindings": {
                "file": "id",
                "fileRevision": "id"
            }
        },
        "files.revisions.download.source": {
            "uri": "files/{file}/revisions/{fileRevision}/download/source",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "file",
                "fileRevision"
            ],
            "bindings": {
                "file": "id",
                "fileRevision": "id"
            }
        },
        "files.folders.destroy": {
            "uri": "files/folders/delete",
            "methods": [
                "DELETE"
            ]
        },
        "files.folders.append": {
            "uri": "files/folders/append/{folderOfFile?}",
            "methods": [
                "POST"
            ],
            "parameters": [
                "folderOfFile"
            ]
        },
        "files.folders.show": {
            "uri": "files/folders/{folderOfFile}",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "folderOfFile"
            ]
        },
        "files.folders.create": {
            "uri": "files/folders/{folderOfFile}/create",
            "methods": [
                "GET",
                "HEAD"
            ],
            "parameters": [
                "folderOfFile"
            ]
        },
        "files.mark_as_final_version": {
            "uri": "files/{file}/mark-as-final-version",
            "methods": [
                "PUT"
            ],
            "parameters": [
                "file"
            ],
            "bindings": {
                "file": "id"
            }
        }
    }
} as const;
export type routes = typeof config.routes;
export default config;
